export const baseTheme = {
  breakpoints: ['767px', '991px', '1024px', '1280px'],
  mediaQueries: {
    mobileOnly: 'screen and (max-width: 766px)',
    tabletPortraitUp: 'screen and (min-width: 767px)',
    tabletLandscapeUp: 'screen and (min-width: 991px)',
    desktopUp: 'screen and (min-width: 1024px)',
    desktopDown: 'screen and (max-width: 1025px)',
    bigDesktopUp: 'screen and (min-width: 1280px)'
  },

  space: [0, 5, 10, 20, 40, 60, 80, 120, 100],
  sizes: [854, 1180],

  fontSizes: {
    xxs: 10,
    xs: 12,
    sm: 14,
    base: 16,
    up: 18,
    md: 24,
    lg: 34,
    xl: 40
  },
  fontWeights: {
    regular: 400,
    body: 400,
    heading: 500,
    button: 600,
    semi: 500,
    semiBold: 600,
    bold: 700
  },
  fonts: {
    body: 'Poppins, sans-serif',
    menu: 'Poppins, sans-serif',
    heading: 'Poppins, sans-serif',
    input: 'Inter, sans-serif'
  },

  // Custom Theme keys
  customs: {
    transition: '0.25s ease-in-out' /* noused */
  },
  lineHeights: {
    body: 1.5,
    button: '24px',
    input: '24px',
    heading: 1.25
  },
  radii: {
    little: '2px',
    small: '5px',
    base: '8px',
    middle: '13px',
    medium: '16px'
  },
  colors: {
    white: '#fff',
    text: {
      default: '#1c505d',
      secondary: '#079391',
      tertiary: '#90a9b0',
      light: '#fff',
      table: '#58667e',
      border: '#d5d9e7'
    },
    body: {
      bg: '#fff',
      text: '#58667e'
    },
    primary: {
      regular: '#329d9c',
      extra: '#4d4d4c'
    },
    secondary: {
      regular: '#1c505d'
    },
    button: {
      regular: '#329d9c',
      hover: '#70bbba',
      active: '#70bbba',
      disabled: '#dcdcdc',
      variant: {
        secondary: {
          regular: '#d5d9e7',
          hover: '#cfd6ec',
          active: '#cfd6ec'
        }
      }
    },
    linkColor: '#1c505d',
    input: {
      regular: '#e2e2e2',
      text: '#4d4d4c',
      bg: '#fff',
      border: '#ababab',
      focus: '#1c505d',
      checkbox: '#c4c4c4',
      textError: '#ff8080',
      placeholder: '#8b8b8b'
    },
    menu: {
      color: '#4d4d4c',
      hover: '#329d9c'
    },
    tooltip: {
      color: '#58667e',
      borderColor: '#fabc73'
    },
    select: {
      label: '#4d4d4c',
      BgColor: '#edeef2'
    }
  },
  shadows: {
    card: '0 0 6px rgba(0, 0, 0, 0.02), 0 2px 4px rgba(0, 0, 0, 0.08)',
    header:
      ' 0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 6px 0px rgba(0, 0, 0, 0.02)',
    section: '0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.08)'
  }
};

export default baseTheme;
